<template>
    <div class="header-component font-adineue-bold bg-black font-normal text-white p-6 uppercase flex justify-center">
        <div class="header-component__container w-4/5 flex items-center">
            <div>
                <img class="mr-16 w-48" src="../assets/media/images/logo-lhs-adidas.svg" alt="Adidas">
            </div>
            <span class="font-bold text-1xl">Asset Name Manager</span>
        </div>
    </div>
</template>

<script>
export default {
    name: 'header-component'
}
</script>

<style scoped lang="scss">
    .header-component {
        &__container {
            max-width: 1600px;
        }
    }
</style>